import { render } from "./TokenManagementView.vue?vue&type=template&id=265b2694&ts=true"
import script from "./TokenManagementView.vue?vue&type=script&lang=ts"
export * from "./TokenManagementView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__